import { useMutation, useQueryClient } from "@tanstack/react-query";

import { useCurrentOrgId } from "@/providers/auth/hooks";
import { useDomainServices } from "@/providers/DomainServices";

import { SetSlackOutboundChannelsInput } from "../SlackService";

import { slackQueryKeys } from "./slackQueryKeys";

/**
 * Save the channels this org's agents may post into. The route answers with the org's whole
 * allowlist, so the response is planted directly and no refetch follows.
 */
export function useSetSlackOutboundChannels(orgId?: string) {
  const { slackService } = useDomainServices();
  const resolvedOrgId = useCurrentOrgId(orgId);
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (request: SetSlackOutboundChannelsInput) =>
      slackService.setOutboundChannels(request, resolvedOrgId),
    onSuccess: async (allowlist) => {
      // An allowlist GET can be in flight — the picker's Refresh does not disable Save. Left
      // running it would resolve after this plant and overwrite the authoritative post-write
      // response with pre-write state, which no refetch then corrects.
      const queryKey = slackQueryKeys.outboundChannels(resolvedOrgId);
      await queryClient.cancelQueries({ queryKey });
      queryClient.setQueryData(queryKey, allowlist);
    },
  });
}
